export default __webpack_public_path__ + "static/faq-laptop-7c8b5a75f01af3d490bd6286e73281cb.jpg";